import { useState } from "react";
import { useNavigate } from "react-router-dom";

import "./Contact07.css";

const FORMSUBMIT_AJAX_URL = "https://formsubmit.co/ajax/contact@served.gg";

function Contact07() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    setIsSubmitting(true);
    setSubmitError(null);

    try {
      const formData = new FormData(form);
      const response = await fetch(FORMSUBMIT_AJAX_URL, {
        method: "POST",
        body: formData,
        headers: { Accept: "application/json" },
      });

      const data = await response.json().catch(() => ({}));

      if (response.ok) {
        navigate("/thank-you");
        return;
      }

      const message =
        typeof data.message === "string" && data.message
          ? data.message
          : "Could not send your application. Please try again.";
      setSubmitError(message);
    } catch {
      setSubmitError(
        "Network error. Please check your connection and try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="Contact07 section" id="Contact07">
      <div className="container">
        <div className="Contact07-box">
          <div className="Contact07-left">
            <p className="eyebrow">APPLICATION FORM</p>
            <h2>
              We partner exclusively with creators who treat their personal
              brand as a serious enterprise.
            </h2>
            <p>
              Please provide your details below. Our board reviews all
              applications within 24 hours. If your profile aligns with our
              network standards, we will reach out with your following steps.
            </p>
          </div>

          <div className="Form07-box" id="Form07">
            <form onSubmit={handleSubmit} method="post">
              <div className="form-group">
                <label htmlFor="name">Name: </label>
                <input type="text" id="name" name="name" required />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email: </label>
                <input type="email" id="email" name="email" required />
              </div>
              <div className="form-group">
                <label htmlFor="platform">OnlyFans or Fansly link:</label>
                <input type="text" id="platform" name="platform" required />
              </div>
              <div className="form-group">
                <label htmlFor="dmca">
                  Have you previously worked with a DMCA service?
                </label>
                <input type="text" id="dmca" name="dmca" required />
              </div>
              <div className="form-group">
                <label htmlFor="referral">
                  Referral / Agency <span>(optional)</span>:
                </label>
                <input type="text" id="referral" name="referral" />
              </div>

              <div className="form-group">
                <label htmlFor="message">
                  Message <span>(optional)</span>:
                </label>
                <textarea id="message" name="message" rows="5"></textarea>
              </div>

              {submitError && (
                <p className="Contact07-form-error" role="alert">
                  {submitError}
                </p>
              )}

              <button
                type="submit"
                className="btn-3"
                disabled={isSubmitting}
                aria-busy={isSubmitting}
              >
                {isSubmitting ? "SENDING…" : "SUBMIT APPLICATION"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact07;
